import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  StyledMarketDataGrid,
  StyledMarketDataLabel,
  StyledMarketDataRow,
  StyledMarketDataValue,
} from '../styled';
import { MarketDataGridProps } from '../types';

/**
 * Market Data Grid Component
 * Displays 24h High, 24h Low, Market Cap, and Supply information
 */
export const MarketDataGrid: FC<MarketDataGridProps> = ({ marketData }) => {
  const { t } = useTranslation('communityStats');

  const formatPrice = (price: number) => {
    return `$${price.toLocaleString('en-US')}`;
  };

  return (
    <StyledMarketDataGrid>
      <StyledMarketDataRow>
        <StyledMarketDataLabel>
          {t('pinnedAssetOverview.marketData.high24h')}
        </StyledMarketDataLabel>
        <StyledMarketDataValue>
          {formatPrice(marketData.high24h)}
        </StyledMarketDataValue>
      </StyledMarketDataRow>

      <StyledMarketDataRow>
        <StyledMarketDataLabel>
          {t('pinnedAssetOverview.marketData.low24h')}
        </StyledMarketDataLabel>
        <StyledMarketDataValue>
          {formatPrice(marketData.low24h)}
        </StyledMarketDataValue>
      </StyledMarketDataRow>

      <StyledMarketDataRow>
        <StyledMarketDataLabel>
          {t('pinnedAssetOverview.marketData.marketCap')}
        </StyledMarketDataLabel>
        <StyledMarketDataValue>
          {marketData.marketCapFormatted ??
            t('pinnedAssetOverview.marketData.notAvailable')}
        </StyledMarketDataValue>
      </StyledMarketDataRow>

      <StyledMarketDataRow>
        <StyledMarketDataLabel>
          {t('pinnedAssetOverview.marketData.supply')}
        </StyledMarketDataLabel>
        <StyledMarketDataValue>
          {marketData.supplyFormatted ??
            t('pinnedAssetOverview.marketData.notAvailable')}
        </StyledMarketDataValue>
      </StyledMarketDataRow>
    </StyledMarketDataGrid>
  );
};
